/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAllParentIntegrationsResponse } from '../../models/get-all-parent-integrations-response';

export interface GetAll_3$Params {
}

export function getAll_3(http: HttpClient, rootUrl: string, params?: GetAll_3$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllParentIntegrationsResponse>> {
  const rb = new RequestBuilder(rootUrl, getAll_3.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAllParentIntegrationsResponse>;
    })
  );
}

getAll_3.PATH = '/v1/parent/integration';
